var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistLavelPayPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#4539cf",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 112.715 6.983",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.33333 0 0 -1.33333 292 544.443)",
    fill: "none",
    stroke: "#4539cf",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0s-11.99 11.06-30.474 5.492c-16.97-5.113-21.184-28.333-9.652-37.379 6.622-5.194 16.586-9.464 30.015-14.211C19.943-56.721 8.833-99.106-21.739-99.31c-11.931-.08-17.509.678-27.99 7.534",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(277.74 397.379)",
    fill: "none",
    stroke: "#4539cf",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-136.148",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(256 418.746)",
    fill: "none",
    stroke: "#4539cf",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-75.696-61.364-137.061-137.061-137.061-75.696 0-137.06 61.365-137.06 137.061 0 75.697 61.364 137.061 137.06 137.061C-61.364 137.061 0 75.697 0 0Z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(393.06 350.671)",
    fill: "none",
    stroke: "#4539cf",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-17.282-13.157-38.854-20.968-62.251-20.968-56.811 0-102.864 46.053-102.864 102.864 0 23.422 7.829 45.016 21.011 62.308",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(318.251 268.776)",
    fill: "none",
    stroke: "#4539cf",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c16.072 10.395 35.228 16.43 55.792 16.43 56.811 0 102.864-46.054 102.864-102.864 0-20.669-6.096-39.914-16.589-56.035",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(200.208 437.106)",
    fill: "none",
    stroke: "#4539cf",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-40.232c0-7.756-6.287-14.043-14.042-14.043h-33.893c-7.754 0-14.042 6.287-14.042 14.043v171.947c0 7.755 6.288 14.042 14.042 14.042h33.893C-6.287 145.757 0 139.47 0 131.715V35.063",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(69.477 88.405)",
    fill: "none",
    stroke: "#4539cf",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 92.152-41.176a63.783 63.783 0 0 1 28.465-3.72L284.846-28.91a63.781 63.781 0 0 1 28.676 10.067l113.366 73.98c9.099 8.08 10.787 21.66 3.94 31.721-7.49 11.009-22.466 13.901-33.517 6.475l-73.169-36.485a149.797 149.797 0 0 0-61.904-15.661l.944 14.805c-1.779 17.883-15.547 32.235-33.341 34.752l-81.778 9.416c-18.864 2.669-28.291 8.99-44.736 18.611v0a146.568 146.568 0 0 1-74.007 20.056H0",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(69.477 69.463)",
    fill: "none",
    stroke: "#4539cf",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 112.715 6.983",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(219 103.668)",
    fill: "none",
    stroke: "#4539cf",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistLavelPayPlan);
export default __webpack_public_path__ + "static/media/assist-lavelPay-plan.3fb6faa6571c5f4574b7a0c4aeffd8fb.svg";
export { ForwardRef as ReactComponent };